module.exports = __webpack_public_path__ + "static/mail-4c1ab589b5e62f0bdd5fc1a59cb0c54c.jpg";